import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import http from "../services/httpService.js";
import "../style/cvePage.css";
import BarLoader from "react-spinners/BarLoader";
const { SERVER_BASE_URL } = require("../env");

function CVEpage() {
  const [cve, setCVE] = useState([]);
  let [loading, setLoading] = useState(true);
  let { cpeId, cveCode } = useParams();

  useEffect(() => {
    async function fetchData() {
      const response = await http.get(
        `${SERVER_BASE_URL}/my-cpes/${cpeId}/cves/${cveCode}`,
        {
          headers: { "x-auth-token": localStorage.getItem("token") },
        }
      );
      response.data.yyyymmdd = response.data.lastModified
        .toString()
        .substring(0, 10);
      setCVE(response.data);
      setLoading(false);
      console.log(response.data);
    }
    fetchData();
  }, []);

  return (
    <div className="centeral-container">
      <BarLoader
        className="mt-3"
        color={"#a4b5ff"}
        loading={loading}
        size={100}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
      {!loading && (
        <div className="cve-card">
          <div className="farsi-bold cve-title">{cve.cveCode}</div>
          <div className="iran-yekan-font cve-text">{cve.text}</div>
          <div className="specifics">
            <div className="farsi">
              <div className="cve-spec">آخرین تغییر: {cve.yyyymmdd}</div>
              <div className="cve-spec">منبع: {cve.source}</div>
              <div className="cve-spec">فرمت: {cve.format}</div>
            </div>
            <div className="farsi">
              <div className="cve-spec">
                نمره قابلیت بهره‌برداری: {cve.exploitabilityScore}
              </div>
              <div className="cve-spec">نمره تاثیر : {cve.impactScore}</div>
              <div className="cve-spec">نمره پایه: {cve.baseScore}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CVEpage;
